<script>
import axios from 'axios';
import { mapActions, mapState } from 'pinia';
import { useUserStore } from '../../../store/useUserStore.js';
import { useHeaderStore } from '../../../store/useHeaderStore.js';
import { useFeedStore } from '../../../store/useFeedStore.js';
import { useCampaignStore } from '../../../store/useCampaignStore.js';

import videoCrowdpacs from './data-seeds/video-crowdpacs';
import { fetchHome, fetchNews, fetchPetitions, fetchRaces, fetchBlogs, fetchPolls, fetchLobbying, fetchEvents, getPersonalData } from '../api/feed';
import { fetchVideos } from '../api/livestreams';
import { newMembers, followNewUser } from '../api/new-members';
import { getNew } from '../api/news';
import { suggestions, followSuggestionUser, followSuggestionCampaign, followSuggestionCandidate } from '../api/suggestions';
import fire from '../firebase';
import VClamp from 'vue-clamp';
import { setUserProfile } from '../api/users';
import { joinOfficialGroups } from '../api/groups';
import moment from 'moment';
import momentTz from 'moment-timezone';
import InfiniteLoading from 'vue-infinite-loading';

const db = fire.firestore();

export default {
  name: 'CpSocialFeedUserHome',
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  components: {
    CpShowMoreList: require('./show-more-list').default,
    CpPageContent: require('../page-content').default,
    CpBox: require('../box').default,
    CpBoxContent: require('../box-content').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpTextInput: require('../inputs/text').default,
    CpUnstyledButton: require('../unstyled-button').default,
    CpIcon: require('../icon').default,
    CpSearchResult: require('../explore-campaigns/result').default,
    CpSocialFeedSidebarMenu: require('./sidebar-menu.vue').default,
    CpSocialFeedNewsPost: require('./posts/news-post').default,
    CpSocialFeedVideoPost: require('./posts/video-post').default,
    CpSocialFeedLivestreamPost: require('./posts/livestream-post').default,
    CpSocialFeedPetitionPost: require('./posts/petition-post').default,
    CpSocialFeedRacePost: require('./posts/race-post').default,
    CpSocialFeedCandidatePost: require('./posts/candidate-post').default,
    CpSocialFeedBlogPost: require('./posts/blog-post').default,
    CpSearch: require('./search').default,
    CpPost: require('./post').default,
    CpMembers: require('./members').default,
    CpBaseSvgIcon: require('../base-svg-icon').default,
    CpButtonLink: require('../button-link').default,
    CpButton: require('../button').default,
    PetitionInfoIcon: require('./icons/petition_info').default,
    BroadcastIcon: require('./icons/broadcast').default,
    SearchIcon: require('./icons/search').default,
    NewsInfoIcon: require('./icons/news-info').default,
    LobbySidebarRightIcon: require('./icons/lobby-sidebar-right').default,
    MembersGradientIcon: require('./icons/members-gradient').default,
    FlagGradientIcon: require('./icons/flag-gradient').default,
    TrumpVsBidenIcon: require('./icons/trump-vs-biden').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    InfiniteLoading,
    CpProfileDialog: require('../dialogs/user-profile').default,
    CpSuggestionDialog: require('../dialogs/user-suggestion').default,
    CpExploreCampaignsForm: require('../explore-campaigns/form').default, //if there is time,
    CpTagsMultiselect: require('../inputs/tags-multiselect').default,
    CpInviteMembersDialog: require('../dialogs/invite-members').default,
    CpTabs: require('../inputs/tabs').default,
    CpTab: require('../inputs/tab').default,
    CpAutoTextarea: require('../inputs/textarea-resize').default,
    CpOpinionsContainer: require('../opinions/opinions-container').default,
    CpOpinionsItem: require('../opinions/opinions-item').default,
    CpSharePostItem: require('../social-feed/posts/share-post-item').default,
    CpImage: require('../image').default,
    VClamp,
    CpTooltipToggle: require('../tooltip-toggle').default,
    CpTooltip: require('../tooltip').default,
    NewMemberAddMobileIcon: require('./icons/new-member-add-mobile').default,
    CpSocialFeedNewMemberPost: require('./posts/new-member-post').default,
    CpProfileDialogZip: require('../dialogs/user-profile-zip.vue').default,
    CpSocialFeedLobbyPost: require('./posts/lobby-post').default,
    CpTvPage: require('../tv/page').default,
    CpSocialFeedCustomContent: require('./posts/CustomContent').default,
    CpSocialFeedCompleteProfile: require('./posts/complete-profile').default,
    CpPostFeedDialog: require('../dialogs/post-feed.vue').default,
    CpSocialFeedPollPost: require('./posts/poll-post').default,
    CpSocialFeedPoliticalActivism: require('./political-activism').default,
    CpEventCard: require('../events/event-card.vue').default,
    CpGroups: require('../groups/groups').default,
    CpJoinGroupDialog: require('../dialogs/join-group').default,
    CpSelect: require('../select').default,
    CpLiveEventDialog: require('../dialogs/live-event').default,
    MinusIcon: require('./icons/minus-icon').default,
    PlusIcon: require('./icons/plus-icon').default,
    CpGroup: require('../groups/group-card').default,
    CpSearchInput: require('../search-input.vue').default,
    CpLivestreamList: require('../livestream/list').default,
    CpDownloadAppDialog: require('../dialogs/download-app').default,
    CpDownloadAppMobileDialog: require('../dialogs/download-app-mobile').default,
    CpSocialFeedSignUpPost: require('./posts/sign-up-post').default,
    CpSocialFeedStartCampaignPost: require('./posts/StartCampaignPost.vue').default,
    CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
    scrollToTop: require('../mixins/utils.js').default,
    CpWelcomeUserDialog: require('../dialogs/WelcomeUser').default,
    CpDropdownMenu: require('./DropdownMenu').default,
    CpCommunitySection: require('./CommunitySection').default,
    CpRepresentativesSection: require('./RepresentativesSection').default,
    CpSocialFeedSubscribeToNewsletter: require('./posts/SubscribeToNewsletter.vue').default,
    CpMyRepresentatives: require('../lobbying/MyRepresentatives.vue').default,
    CpFeaturedCampaigns: require('./FeaturedCampaigns.vue').default,
    CpCommunityComments: require('./CommunityComments.vue').default,
    CpLatestNews: require('../news/LatestNews').default,
    CpExploreNewMembers: require('../components/ExploreNewMembers').default,
  },
  data: function () {
    return {
      appUrl: process.env.MIX_APP_URL,
      videoCrowdpacs: videoCrowdpacs,
      activeDataCategory: 'home',
      showInviteDialog: false,
      rssNewsItems: [],
      petitions: [],
      newId: null,
      newParam: null,
      showButtonNewPosts: false,
      videos: [],
      videosPage: 0,
      blogs: [],
      blogsPage: 0,
      polls: [],
      pollsPage: 0,
      pollsQuery: '',
      pollsType: ['all'],
      pollsSort: 'created',
      pollSortArray: [
        {
          value: 'created',
          title: 'Recently posted',
        },
        {
          value: 'trending',
          title: 'Trending',
        },
      ],
      pollTypeArray: [
        {
          value: 'all',
          title: 'All polls',
        },
        {
          value: 'finished',
          title: 'Finished',
        },
        {
          value: 'live',
          title: 'Live',
        },
        {
          value: 'voted',
          title: 'Voted',
        },
      ],
      isOpenPollFilter: false,
      infiniteLoadingPoll: false,
      lobbies: [],
      lobbiesPage: 0,
      feedItems: [],
      races: [],
      invitingUser: {},
      user: {},
      newsPage: 0,
      petitionsPage: 0,
      feedItemsPage: 0,
      racesPage: 0,
      query: '',
      officialGroup: '',
      tags: [],
      suggestions: [],
      new_members: [],
      connections: 'all',
      currentTabMembers: 'members',
      lastFeedUpdate: new Date(),
      loadingFollow: false,
      followingIndex: undefined,
      indexClickedNewUser: undefined,
      loadingNewMembers: true,
      showProfileDialog: this.showDialog,
      showSuggestionDialog: false,
      loadingSuggestions: true,
      loadingNew: false,
      showZipDialog: false,
      showBannerZip: this.currentUser && (!this.currentUser?.address_zip || this.currentUser?.address_zip == '') && !this.currentUser?.unset_zipcode,
      showModalFeed: this.modalFeed,
      posts: '0',
      pageNews: 0,
      newsWithoutActivity: 0,
      nowEastern: null,
      liveEvents: [],
      idLiveEvents: [],

      // events
      events: [],
      eventsSearch: '',
      eventsPage: 0,
      eventsTagsSelected: [],
      eventsStatesSelected: [],
      eventsType: 'all',
      eventsTypeOptions: [
        {
          value: 'all',
          title: 'All events',
        },
        {
          value: 'created',
          title: 'Created events',
        },
      ],
      eventsAssistanceType: null,
      eventsAssistanceTypeOptions: [
        {
          value: 'online',
          title: 'Online',
        },
        {
          value: 'in-person',
          title: 'In person',
        },
      ],
      isOpenEventFilter: false,
      isOpenEventType: false,
      isOpenEventTags: false,
      isOpenEventStates: false,
      isOpenEventAssistance: false,
      infiniteLoadingEvents: null,

      // groups
      groups: [],
      groupsPage: 0,
      groupsQuery: '',
      groups_tags: [],
      groups_tags_selected: [],
      groups_states_selected: [],
      groupsType: 'all',
      groupsTypeArray: [
        {
          value: 'all',
          title: 'All groups',
        },
        {
          value: 'joined',
          title: 'Joined groups',
        },
        {
          value: 'created',
          title: 'Created groups',
        },
      ],
      groupsPrivacyType: null,
      groupsPrivacyTypeArray: [
        {
          value: null,
          title: 'All groups',
        },
        {
          value: '1',
          title: 'Public',
        },
        {
          value: '0',
          title: 'Private',
        },
      ],
      isOpenGroupFilter: false,
      isOpenGroupType: false,
      isOpenGroupTags: false,
      isOpenGroupStates: false,
      isOpenGroupPrivacy: false,
      isOpenDownloadApp: false,
      isOpenDownloadAppMobile: false,
      hasEnteredWithin24Hours: false,
      isFirstIncome: true,
      showAuthModal: false,
      followingUserId: null,
      followingCampaignId: null,
      followingCandidateId: null,
      clickedNewUserId: null,
      isLoginCallbackActive: false,
      currentUser: this.userData,
      followed: this.membersFollowed,
      waiting: this.membersWaiting,
      isProfileCompleted: this.isProfileCompletedToFeed,
      isLoginToMembersSection: false,
      isLoginToEventsSection: false,
      isStartingLobby: false,
      isOpenWelcomeUser: true,
      typeParam: '',
      idParam: null,
    };
  },
  async updated() {
    if (this.isUserLogin && !this.currentUser) {
      await this.getUserProfile();
      this.currentUser = this.userProfileData;
      (this.followed = this.usersFollowed),
        (this.waiting = this.usersWaiting),
        (this.isProfileCompleted =
          this.currentUser.email_verified &&
          this.currentUser.address_state &&
          this.currentUser.address_zip &&
          this.currentUser.image &&
          this.currentUser.political_party &&
          this.currentUser.tags.length > 0);
    }
    if (this.activeDataCategory == 'campaigns') {
      this.setIsCampaignSection(true);
    } else {
      this.setIsCampaignSection(false);
    }
  },
  props: {
    rallyInCourse: { type: Boolean, default: false },
    rally: { type: Object, default: {} },
    showDialog: { type: Boolean, default: false },
    isProfileCompletedToFeed: { type: Boolean, default: false },
    userData: { type: Object, default: {} },
    affiliations: { type: Array, default: {} },
    campaignTags: { type: Array, default: {} },
    states: { type: Array, default: [] },
    types: { type: Array, default: [] },
    years: { type: Array, default: [] },
    genders: { type: Array, default: [] },
    resultsUrlSuffix: { type: String, default: '' },
    membersFollowed: 0,
    membersWaiting: 0,
    placeholderStatusPost: { type: String },
    modalFeed: { type: Boolean, default: false },
    modalType: { type: String, default: null },
    publication: { type: Object, default: {} },
    post: { type: Object, default: {} },
  },
  async created() {
    const url = new URL(window.location.href);
    const anchor = url.searchParams.get('anchor');

    if (anchor === 'post' && !url.hash) {
      url.hash = '#post';
      window.history.replaceState(null, '', url.toString());
    }

    const category = window.location.hash.slice(1);
    if (
      [
        'home',
        'community',
        'campaigns',
        'news',
        'tv',
        'petitions',
        'members',
        'races',
        'search',
        'post',
        'blogs',
        'representatives',
        'polls',
        'groups',
        'events',
      ].includes(category)
    ) {
      this.activeDataCategory = category;
      this.updateSidebarCategoty(category);
    }
    if (category == 'my-connections') {
      this.activeDataCategory = 'members';
      this.updateSidebarCategoty(category);
      this.currentTabMembers = 'myconnnections';
      this.connections = 'myconnnections';
    }
    if (category == 'suggested' || category == 'joined' || category == 'created') {
      this.activeDataCategory = 'groups';
      this.updateSidebarCategoty(category);
      this.currentTabGroups = 'suggested';
    }
    if (category == 'campaigns') {
      this.setIsCampaignSection(true);
    } else {
      this.setIsCampaignSection(false);
    }

    const currentUrl = window.location.search;
    const arrayParams = currentUrl.substr(1).split('&');
    const arrayFirstParam = arrayParams[0].split('=');
    if (arrayFirstParam[0] == 'new_id') {
      this.newId = arrayFirstParam[1];
      this.loadingNew = true;
      getNew(this.newId)
        .then(response => {
          this.newParam = response.new;
          this.loadingNew = false;
        })
        .catch(error => {
          this.loadingNew = false;
          console.warn(error);
        });
    }
    const urlParams = new URLSearchParams(currentUrl);
    const isSignup = urlParams.get('isSignup');
    this.typeParam = urlParams.get('type');
    this.idParam = urlParams.get('id');
    await this.handleSocialNetworkSignUp(isSignup === '1');
  },
  mounted() {
    this.verifyEventInCourse();
    setInterval(() => {
      this.verifyEventInCourse();
    }, 60000); // 60 seconds

    const storedTimestamp = localStorage.getItem('saveTimestampEnterPage');
    let counter = parseInt(localStorage.getItem('incomeCounter'), 10) || 0;

    if (storedTimestamp) {
      const hoursDifference = (Date.now() - parseInt(storedTimestamp)) / (1000 * 60 * 60);
      if (hoursDifference < 24) {
        this.hasEnteredWithin24Hours = true;
        this.isFirstIncome = false;
      }
    }

    if (!storedTimestamp && this.isFirstIncome) {
      localStorage.setItem('saveTimestampEnterPage', Date.now().toString());
    }

    if (!this.hasEnteredWithin24Hours && counter < 4) {
      counter += 1;
      localStorage.setItem('incomeCounter', counter);
    }

    this.lastFeedUpdate = new Date();
    const self = this;
    suggestions()
      .then(response => {
        this.suggestions = response.suggestions;
        this.loadingSuggestions = false;
      })
      .catch(error => {
        this.loadingSuggestions = false;
        console.warn(error);
      });
    newMembers()
      .then(response => {
        this.new_members = response.new_members;
        this.loadingNewMembers = false;
      })
      .catch(error => {
        this.loadingNewMembers = false;
        console.warn(error);
      });

    if (this.currentUser && !this.currentUser?.joined_official_groups) {
      joinOfficialGroups();
    }

    db.collection('feed_updated')
      .orderBy('created_at', 'desc')
      .limit(1)
      .onSnapshot(async function (querySnapshot) {
        await querySnapshot.docs.map(function (doc) {
          const datePost = doc.data().created_at.toDate();
          const user_id = doc.data().user_id;
          const currentUser = self.isUserLogin ? self.userLoginData.id : null;
          if (datePost.getTime() > self.lastFeedUpdate && user_id != currentUser) {
            self.showButtonNewPosts = true;
          }
        });
      });

    const tagsResponse = axios.get('/apiv2/tags', { params: { is_default: true } });
    tagsResponse.then(response => {
      // We work with tags as strings on the front end.
      this.groups_tags = response.data.data.tags.map(tag => tag);
    });
    if (counter === 3) {
      if (this.$root.isMobile) {
        this.handleOpenDownloadApp();
      }
      if (!this.$root.isMobile) {
        this.handleOpenDownloadAppMobile();
      }
    }
  },
  methods: {
    verifyEventInCourse() {
      const self = this;
      this.nowEastern = momentTz.tz(moment(), 'America/New_York').format('YYYY-MM-DD H:mm');

      db.collection('group_events')
        .where('start', '>=', this.nowEastern)
        .orderBy('start', 'asc')
        .limit(10)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const nowEastern = momentTz.tz(moment(), 'America/New_York').format('YYYY-MM-DD H:mm');
            const startEvent = momentTz.tz(doc.data().start, 'America/New_York').format('YYYY-MM-DD H:mm');
            if (startEvent == nowEastern && !self.idLiveEvents.includes(doc.data().event_id)) {
              self.idLiveEvents.push(doc.data().event_id);
              self.liveEvents.push(doc.data());
            }
          });
        });
    },
    async updateFeed() {
      this.showModalFeed = false;
      window.scrollTo({
        top: 350,
        left: 0,
        behavior: 'smooth',
      });
      await this.emptyFeed();
      this.showButtonNewPosts = false;
    },
    emptyFeed() {
      this.feedItemsPage = 0;
      this.feedItems = [];
      this.posts = '0';
      this.pageNews = 0;
      this.newsWithoutActivity = 0;
    },
    handleZipDialog(value) {
      this.showZipDialog = value;
      if (this.showZipDialog && this.errorUpdateProfileUser) {
        this.errorUpdateProfileUser = null;
      }
    },
    handleBannerZip(value) {
      this.showBannerZip = value;
    },
    setCurrentUserZip(zip) {
      this.currentUser.address_zip = zip;
      this.currentUser.unset_zipcode = false;
    },
    closeZipDialog() {
      this.showBannerZip = false;
      setUserProfile({ unset_zipcode: true })
        .then(() => {
          this.currentUser.address_zip = this.nonExistentZip;
        })
        .catch(({ message }) => {
          console.error(message);
        });
    },
    clearUrl() {
      const baseUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, baseUrl);
    },
    handleSidebarLinkClicked(category) {
      this.clearUrl();
      this.scrollToTop();
      if (category === 'members' && !this.currentUser) {
        this.showAuthModal = true;
        this.isLoginToMembersSection = true;
        return;
      }
      if (category === 'events' && !this.currentUser) {
        this.showAuthModal = true;
        this.isLoginToEventsSection = true;
        return;
      }
      if (this.activeDataCategory != 'home' && category === 'home') {
        this.emptyFeed();
        this.activeDataCategory = category;
        this.updateSidebarCategoty(category);
      } else {
        this.activeDataCategory = category;
        this.updateSidebarCategoty(category);
      }
    },
    handleFollowMore() {
      this.activeDataCategory = 'members';
    },
    handleInviteButtonClicked() {
      this.showInviteDialog = !this.showInviteDialog;
    },
    clearQuery() {
      this.query = '';
    },
    loadVideos($state) {
      fetchVideos({ page: this.videosPage, type: 'all' })
        .then(response => {
          if (response.videos.length) {
            this.videos = this.videos.concat(response.videos);
            this.videosPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    loadNews($state) {
      fetchNews({ page: this.newsPage })
        .then(async response => {
          this.user = response.user;
          if (response.news.length) {
            const { news } = response;

            const postsIdsWithoutDuplicates = news.map(post => [post.id, 'news']).filter(([id]) => this.rssNewsItems.findIndex(item => item.id == id) == -1);

            await getPersonalData({ posts: postsIdsWithoutDuplicates })
              .then(response => {
                const { personal_data } = response;

                for (const personal of personal_data) {
                  const newsIndex = news.findIndex(post => post.id == personal.id);

                  if (newsIndex > -1) {
                    news[newsIndex] = {
                      ...news[newsIndex],
                      ...personal,
                    };
                  }
                }
              })
              .catch(error => {
                console.warn(error);
              });

            this.rssNewsItems = this.combineNewsItems(this.rssNewsItems, news);
            this.newsPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    loadHome($state) {
      fetchHome({ page: this.feedItemsPage, newsWithoutActivity: this.newsWithoutActivity })
        .then(async response => {
          this.user = response.user;
          if (response.feed_items.length) {
            const { feed_items } = response;

            const postsIdsWithoutDuplicates = feed_items
              .map(post => [post.data.id, post.feed_item_type])
              .filter(([id, feed_item_type]) => this.feedItems.findIndex(item => item.data.id == id && item.feed_item_type == feed_item_type) == -1);

            await getPersonalData({ posts: postsIdsWithoutDuplicates })
              .then(response => {
                const { personal_data } = response;

                for (const personal of personal_data) {
                  const { id, feed_item_type, ...rest } = personal;
                  const feedItem = feed_items.find(post => post.data.id == id && post.feed_item_type == feed_item_type);

                  if (feedItem) {
                    feedItem.data = {
                      ...feedItem.data,
                      ...rest,
                    };
                  }
                }
              })
              .catch(error => {
                console.warn(error);
              });

            this.feedItems = this.combineFeedItems(this.feedItems, feed_items);
            this.feedItemsPage += 1;
            this.newsWithoutActivity = response.newsWithoutActivity;

            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    combineNewsItems(currItems, newItems) {
      const items = [...currItems];

      for (const newItem of newItems) {
        const index = items.findIndex(post => post.id == newItem.id);

        if (index > -1) {
          items[index] = { ...items[index], ...newItem };
        } else {
          items.push(newItem);
        }
      }

      return items;
    },
    combineFeedItems(currItems, newItems) {
      const items = [...currItems];

      for (const newItem of newItems) {
        const index = items.findIndex(post => post.data.id == newItem.data.id && post.feed_item_type == newItem.feed_item_type);

        if (index > -1) {
          items[index].data = { ...items[index].data, ...newItem.data };
        } else {
          items.push(newItem);
        }
      }

      return items;
    },
    loadBlogs($state) {
      fetchBlogs({ page: this.blogsPage })
        .then(response => {
          if (response.blogs.length) {
            this.blogs = this.blogs.concat(response.blogs);
            this.blogsPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    openPollFilter() {
      this.isOpenPollFilter = !this.isOpenPollFilter;
    },
    resetPollTypes() {
      this.pollsType = ['all'];
    },
    handleCheckboxChange(event) {
      if (event.target.value !== 'all') {
        this.pollsType = this.pollsType.filter(value => value !== 'all');
      } else {
        this.pollsType = ['all'];
      }
    },
    handleSearch() {
      if (this.activeDataCategory == 'polls') {
        this.pollsPage = 0;
        this.polls = [];
        this.$refs.infiniteLoadingPoll.stateChanger.reset();
        this.$refs.infiniteLoadingPoll.$emit('infinite', this.polls);
      }

      if (this.activeDataCategory == 'events') {
        this.eventsPage = 0;
        this.events = [];
        this.$refs.infiniteLoadingEvents.stateChanger.reset();
        this.$refs.infiniteLoadingEvents.$emit('infinite', this.events);
      }

      if (!this.$root.isMobile) {
        this.scrollToTop();
      }
    },
    loadPolls($state) {
      fetchPolls({ page: this.pollsPage, query: this.pollsQuery, type: this.pollsType, sort: this.pollsSort })
        .then(response => {
          if (response.polls.length) {
            this.polls = this.polls.concat(response.polls);
            this.pollsPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    loadEvents($state) {
      fetchEvents({
        page: this.eventsPage,
        type: this.eventsType,
        query: this.eventsSearch,
        assistance: this.eventsAssistanceType,
        tags: this.eventsTagsSelected,
        states: this.eventsStatesSelected,
      })
        .then(response => {
          if (response.events.length) {
            this.events = this.events.concat(response.events);
            this.eventsPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    loadLobbies($state) {
      fetchLobbying({ page: this.lobbiesPage, type_charge: 'all' })
        .then(response => {
          if (response.lobbies.length) {
            this.lobbies = this.lobbies.concat(response.lobbies);
            this.lobbiesPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    loadPetitions($state) {
      fetchPetitions({ page: this.petitionsPage })
        .then(response => {
          if (response.petitions.length) {
            this.petitions = this.petitions.concat(response.petitions);
            this.petitionsPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    loadRaces($state) {
      fetchRaces({ page: this.racesPage })
        .then(response => {
          if (response.elections.length) {
            this.races = this.races.concat(response.elections);
            this.racesPage += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    handleTagsChange(tags) {
      this.tags = tags.map(tag => tag.id);
    },
    handleProfileDialog(value) {
      this.showProfileDialog = value;
    },
    handleSuggestionDialog(value, action) {
      this.showSuggestionDialog = value;
      if (action == 'load') {
        this.loadingSuggestions = true;
        suggestions()
          .then(response => {
            this.suggestions = response.suggestions;
            this.loadingSuggestions = false;
          })
          .catch(error => {
            this.loadingSuggestions = false;
            console.warn(error);
          });
      } else if (action == 'finish') {
        this.showBannerZip = false;
        this.loadingSuggestions = true;
        suggestions()
          .then(response => {
            this.suggestions = response.suggestions;
            this.loadingSuggestions = false;
          })
          .catch(error => {
            this.loadingSuggestions = false;
            console.warn(error);
          });
        newMembers()
          .then(response => {
            this.new_members = response.new_members;
            this.loadingNewMembers = false;
          })
          .catch(error => {
            this.loadingNewMembers = false;
            console.warn(error);
          });
      }
    },
    handleCloseButton() {
      this.showAuthModal = false;
      const isSocialLogin = window.sessionStorage.getItem('openWindowForSocialLogin');
      if (!this.isLoginCallbackActive && !isSocialLogin) {
        if (this.isLoginToMembersSection && !this.currentUser) {
          this.$refs.sidebarMenu.handleLinkClick(this.activeDataCategory);
        }
        if (this.isLoginToEventsSection && !this.currentUser) {
          this.$refs.sidebarMenu.handleLinkClick(this.activeDataCategory);
        }
        this.followingIndex = undefined;
        this.followingUserId = null;
        this.followingCampaignId = null;
        this.followingCandidateId = null;
        this.indexClickedNewUser = undefined;
        this.clickedNewUserId = null;
        this.isStartingLobby = false;
        this.isLoginToMembersSection = false;
        this.isLoginToEventsSection = false;
      }
    },
    async loginCallbackAction() {
      this.isLoginCallbackActive = true;
      if (this.followingUserId) {
        await this.handleFollowSuggestionUser();
      } else if (this.followingCampaignId) {
        await this.handleFollowSuggestionCampaign();
      } else if (this.followingCandidateId) {
        await this.handleFollowSuggestionCandidate();
      } else if (this.clickedNewUserId) {
        await this.handleFollowNewUser();
      } else if (this.isLoginToMembersSection) {
        this.activeDataCategory = 'members';
        this.isLoginToMembersSection = false;
      } else if (this.isLoginToEventsSection) {
        this.activeDataCategory = 'events';
        this.isLoginToEventsSection = false;
      } else if (this.isStartingLobby) {
        this.handleStartLobby();
      }
      this.isLoginCallbackActive = false;
    },
    startLobby() {
      if (!this.isUserLogin) {
        this.isStartingLobby = true;
        this.showAuthModal = true;
      } else {
        this.handleStartLobby();
      }
    },
    handleStartLobby() {
      window.location.href = 'representatives';
    },
    followUser(user_id, index) {
      this.followingUserId = user_id;
      this.followingIndex = index;
      this.loadingFollow = true;

      if (!this.isUserLogin) {
        this.showAuthModal = true;
      } else {
        this.handleFollowSuggestionUser();
      }
    },
    handleFollowSuggestionUser() {
      followSuggestionUser(this.followingUserId)
        .then(response => {
          console.log({ inPre: this.followingIndex });
          this.suggestions = this.suggestions.filter((_, i) => i != this.followingIndex);
        })
        .finally(() => {
          this.followingUserId = null;
          this.followingIndex = undefined;
          this.loadingFollow = false;
        });
    },
    followCampaign(campaign_id, index) {
      this.followingCampaignId = campaign_id;
      this.followingIndex = index;
      this.loadingFollow = true;

      if (!this.isUserLogin) {
        this.showAuthModal = true;
      } else {
        this.handleFollowSuggestionCampaign();
      }
    },
    handleFollowSuggestionCampaign() {
      followSuggestionCampaign({ type: 'crowdpac_follow', type_id: this.followingCampaignId }).then(response => {
        this.suggestions = this.suggestions.filter((_, i) => i != this.followingIndex);
        this.followingCampaignId = null;
        this.followingIndex = undefined;
        this.loadingFollow = false;
      });
    },
    followCandidate(candidate_id, index) {
      this.followingCandidateId = candidate_id;
      this.followingIndex = index;
      this.loadingFollow = true;

      if (!this.isUserLogin) {
        this.showAuthModal = true;
      } else {
        this.handleFollowSuggestionCandidate();
      }
    },
    handleFollowSuggestionCandidate() {
      followSuggestionCandidate({ type: 'candidate_follow', type_id: this.followingCandidateId }).then(response => {
        this.suggestions = this.suggestions.filter((_, i) => i != this.followingIndex);
        this.followingCandidateId = null;
        this.followingIndex = undefined;
        this.loadingFollow = false;
      });
    },
    followNewUser(user_id, index) {
      this.clickedNewUserId = user_id;
      this.indexClickedNewUser = index;

      if (!this.isUserLogin) {
        this.showAuthModal = true;
      } else {
        this.handleFollowNewUser();
      }
    },
    handleFollowNewUser() {
      followNewUser(this.clickedNewUserId).then(response => {
        this.indexClickedNewUser = undefined;
        this.clickedNewUserId = null;
        this.loadingNewMembers = true;
        newMembers()
          .then(response => {
            this.new_members = response.new_members;
            this.loadingNewMembers = false;
          })
          .catch(error => {
            this.loadingNewMembers = false;
            console.warn(error);
          });
      });
    },
    handleFeedDialog() {
      this.showModalFeed = !this.showModalFeed;
    },
    handleJoinGroupDialog(value) {
      this.showJoinGroupDialog = value;
    },
    closeLiveEventDialog() {
      this.liveEvents = [];
      suggestions().then(response => {
        this.suggestions = response.suggestions;
      });
      newMembers().then(response => {
        this.new_members = response.new_members;
      });
    },
    resetEventsFilters() {
      this.eventsType = 'all';
      this.eventsTagsSelected = [];
      this.eventsStatesSelected = [];
      this.eventsAssistanceType = '';
    },
    handleEventFilter() {
      this.isOpenEventFilter = !this.isOpenEventFilter;
    },
    handleEventType() {
      this.isOpenEventType = !this.isOpenEventType;
    },
    handleEventTags() {
      this.isOpenEventTags = !this.isOpenEventTags;
    },
    handleEventStates() {
      this.isOpenEventStates = !this.isOpenEventStates;
    },
    handleEventAssistance() {
      this.isOpenEventAssistance = !this.isOpenEventAssistance;
    },
    resetGroupsFilters() {
      this.groupsType = 'all';
      this.groups_tags_selected = [];
      this.groups_states_selected = [];
      this.groupsPrivacyType = '';
    },
    handleGroupFilter() {
      this.isOpenGroupFilter = !this.isOpenGroupFilter;
    },
    handleGroupType() {
      this.isOpenGroupType = !this.isOpenGroupType;
    },
    handleGroupTags() {
      this.isOpenGroupTags = !this.isOpenGroupTags;
    },
    handleGroupStates() {
      this.isOpenGroupStates = !this.isOpenGroupStates;
    },
    handleGroupPrivacy() {
      this.isOpenGroupPrivacy = !this.isOpenGroupPrivacy;
    },
    handleOpenDownloadApp() {
      this.isOpenDownloadApp = !this.isOpenDownloadApp;
    },
    handleOpenDownloadAppMobile() {
      this.isOpenDownloadAppMobile = !this.isOpenDownloadAppMobile;
    },
    handleOpenWelcomeUser() {
      this.isOpenWelcomeUser = !this.isOpenWelcomeUser;
    },
    ...mapActions(useUserStore, ['getUserProfile', 'handleSocialNetworkSignUp']),
    ...mapActions(useFeedStore, ['updateSidebarCategoty']),
    ...mapActions(useCampaignStore, ['setIsCampaignSection']),
  },
  computed: {
    ...mapState(useUserStore, [
      'isSocialNetworkSignUp',
      'isUserLoginLoading',
      'isUserLogin',
      'sidebarCategory',
      'userLoginData',
      'userProfileData',
      'usersFollowed',
      'usersWaiting',
    ]),
    ...mapState(useHeaderStore, ['sitewideBannerInfo']),
    ...mapState(useFeedStore, ['sidebarCategory']),
    calculatedStickySidebarTop() {
      return this.sitewideBannerInfo.visible ? 80 + this.sitewideBannerInfo.height : 80;
    },
    authUser() {
      return this.$root.authUser;
    },
    isHome() {
      return this.activeDataCategory == 'home';
    },
    showLiveEventDialog() {
      return !this.showSuggestionDialog && !this.showZipDialog && !this.showJoinGroupDialog && this.liveEvents.length > 0;
    },
    suggestionsToShow() {
      return this.suggestions.slice(0, 5);
    },
  },
  watch: {
    pollsQuery: 'handleSearch',
    pollsType: 'handleSearch',
    pollsSort: 'handleSearch',
    eventsSearch: 'handleSearch',
    eventsType: 'handleSearch',
    eventsAssistanceType: 'handleSearch',
    eventsTagsSelected: 'handleSearch',
    eventsStatesSelected: 'handleSearch',
  },
};
</script>

<template>
  <div>
    <!-- Button new posts for update feed -->
    <div v-if="isHome && showButtonNewPosts && !showModalFeed" class="button-new-posts-container">
      <cp-button primary @click="updateFeed" class="button-new-posts">
        <cp-icon name="arrow-up" style="margin-top: -3px"></cp-icon>
        <span>New Posts</span>
      </cp-button>
    </div>
    <!-- I commented this code because we change the sign-up flow -->
    <!-- <cp-profile-dialog
      v-if="!showProfileDialog"
      :full-screen="true"
      :user="currentUser"
      :handleProfileDialog="handleProfileDialog"
      :handleSuggestionDialog="handleSuggestionDialog"
      :states="states"
    /> -->
    <cp-suggestion-dialog
      v-if="showSuggestionDialog"
      :full-screen="true"
      :suggestions="suggestions"
      :handleSuggestionDialog="handleSuggestionDialog"
      :handleProfileDialog="handleProfileDialog"
      :handleJoinGroupDialog="handleJoinGroupDialog"
      :user="currentUser"
      :loadingSuggestions="loadingSuggestions"
      v-bind:class="{ 'not-sticky': !!showInviteDialog }"
    />
    <cp-post-feed-dialog
      v-if="showModalFeed && !showSuggestionDialog"
      :handleFeedDialog="handleFeedDialog"
      :user="currentUser"
      :updateFeed="updateFeed"
      :placeholderStatusPost="placeholderStatusPost"
      :publication="publication"
      :post="post"
      :modalType="modalType"
      v-bind:class="{ 'not-sticky': !!showInviteDialog }"
    />
    <!-- <cp-join-group-dialog
            v-if="showJoinGroupDialog"
            :handleJoinGroupDialog="handleJoinGroupDialog"
            :setCurrentJoinedOfficialGroups="setCurrentJoinedOfficialGroups"
            v-bind:class="{ 'not-sticky': !!showInviteDialog }"
        /> -->
    <cp-live-event-dialog
      v-if="showLiveEventDialog"
      :closeLiveEventDialog="closeLiveEventDialog"
      :events="liveEvents"
      v-bind:class="{ 'not-sticky': !!showInviteDialog }"
    />
    <cp-box style="margin-top: 10px; overflow: unset">
      <cp-box-content style="max-width: 1400px; margin: 0 auto" :class="{ mobile: $root.isMobile, tablet: $root.isTablet }">
        <cp-grid class="social-feed-box-wrapper" :class="{ mobile: $root.isMobile }">
          <!-- ------- SIDEBAR MENU ------- -->
          <cp-grid-item :span="$root.isMobile ? 1.4 : 2" style="position: relative; z-index: 9998">
            <div :style="{ top: `${calculatedStickySidebarTop}px` }">
              <cp-social-feed-sidebar-menu
                ref="sidebarMenu"
                @sidebarLinkClicked="handleSidebarLinkClicked"
                :category="activeDataCategory"
              ></cp-social-feed-sidebar-menu>
              <CpDropdownMenu v-margin-top="0.3" v-margin-bottom="0.8" />
              <cp-invite-members-dialog
                :url="`${appUrl}/feed`"
                :title="!!currentUser ? `${currentUser.fullname} wants you to join CrowdBlue!` : `You have been invited to join CrowdBlue!`"
                :description="!!currentUser ? `${currentUser.fullname} wants you to join CrowdBlue!` : `You have been invited to join CrowdBlue!`"
                quote
                twitter-user="crowdblue"
                hashtags="crowdBlue,politics,political crowdfunding"
                :inviting-user-id="!!currentUser ? currentUser.id : '0'"
                @inviteButtonClicked="handleInviteButtonClicked"
              />
              <div class="my-representatives" v-if="!$root.isMobile">
                <CpMyRepresentatives v-margin-top=".3" />
              </div>
            </div>
          </cp-grid-item>
          <!-- ------- FEED LIST ------- -->
          <cp-grid-item :span="$root.isMobile ? 10.6 : 7.5" class="social-feed-wrapper" v-bind:class="{ 'not-sticky': !!showInviteDialog }">
            <transition name="feed-fade" mode="out-in">
              <div v-if="activeDataCategory == 'home'" class="home-feed-wrapper" key="campaigns">
                <div v-if="!isUserLogin && $root.isMobile" class="sign-up-post-mobile" v-margin-bottom="1">
                  <CpSocialFeedSignUpPost />
                </div>
                <div v-margin-bottom="1">
                  <cp-social-feed-complete-profile v-if="$root.isMobile && isUserLogin && currentUser && !isProfileCompleted" :user="currentUser" />
                </div>

                <div v-if="loadingNewMembers && $root.isMobile" class="heading-4" style="text-align: center">
                  <vue-simple-spinner />
                </div>

                <cp-grid align="center" v-else-if="$root.isMobile && new_members.length">
                  <cp-grid-item
                    v-for="(new_member, index) in new_members"
                    :key="new_member.id"
                    :span="2.4"
                    class="social-feed-post-profile-wrapper"
                    style="justify-content: center; display: block"
                  >
                    <div class="profile-img social-feed-default-img" style="background: none; text-align: center; width: 100%">
                      <a :href="new_member.permalink">
                        <cp-image
                          class="position-image-mobile"
                          :src="new_member.imageFeed"
                          circular
                          :width="$root.isMobile ? '25' : '40'"
                          :height="$root.isMobile ? '25' : '40'"
                        ></cp-image>
                      </a>
                    </div>
                    <div style="text-align: center">
                      <a @click="followNewUser(new_member.id, index)">
                        <cp-base-svg-icon :width="20" :height="19" :viewBox="'0 0 20 19'" :icon-color="'none'" :stroke-color="'none'">
                          <new-member-add-mobile-icon />
                        </cp-base-svg-icon>
                      </a>
                    </div>
                  </cp-grid-item>
                </cp-grid>

                <cp-livestream-list :current-user="currentUser" />

                <cp-opinions-container
                  :current-user="currentUser"
                  :name="currentUser != null ? currentUser.first_name : ''"
                  :placeholder-status-post="placeholderStatusPost"
                  :reload="updateFeed"
                />
                <div v-if="rallyInCourse" class="feed-rally-player-wrapper">
                  <cp-tv-page
                    v-if="rally.stream_url == null || rally.stream_url.length == 0"
                    :rally-in-course="rallyInCourse"
                    :explore="true"
                    :rally="rally"
                    class="feed-rally-player"
                  />
                  <iframe
                    v-else
                    width="560"
                    height="420"
                    class="rally-player"
                    :src="'https://www.youtube.com/embed/' + rally.stream_url"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </div>
                <div v-else-if="newId && !rallyInCourse" style="background: rgba(255, 190, 171, 0.33)">
                  <div v-if="loadingNew" class="heading-4">
                    <vue-simple-spinner v-margin="1" />
                    <span style="display: flex; justify-content: center">Loading new...</span>
                  </div>
                  <div v-else>
                    <div class="pinnedText">
                      <i class="fa fa-map-pin" style="margin-right: 10px" />
                      <span v-if="!$root.isMobile">Pinned Story</span>
                    </div>
                    <cp-social-feed-news-post :key="newId" :news="newParam" :explore="true" :pinned="true" />
                  </div>
                </div>
                <transition-group name="feed-fade">
                  <div v-for="(feedItem, index) in feedItems" :key="feedItem.feed_item_type.toString() + '-' + index.toString()">
                    <div v-if="feedItem.feed_item_type == 'campaign'" style="margin-bottom: 2.5em">
                      <cp-search-result
                        :result="feedItem.data"
                        :explore="true"
                        :feed="true"
                        :current-user="currentUser"
                        :modal="showInviteDialog"
                        :results-url-suffix="resultsUrlSuffix"
                      ></cp-search-result>
                    </div>
                    <div v-if="feedItem.feed_item_type == 'custom_content'">
                      <CpSocialFeedCustomContent :post="feedItem.data" :explore="true" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'opinion'">
                      <cp-opinions-item :data="feedItem.data" :explore="true" :reload="updateFeed" :type="'opinion'" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'blog'">
                      <cp-social-feed-blog-post :key="feedItem.id" :blog="feedItem.data" :explore="true" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'candidate'">
                      <cp-social-feed-candidate-post
                        :key="feedItem.id"
                        :candidate="feedItem.data"
                        :for-share="false"
                        :explore="true"
                        :modal="showInviteDialog"
                        :iconState="true"
                      />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'news' && feedItem.data.id != newId">
                      <cp-social-feed-news-post :key="feedItem.rss_article_url" :news="feedItem.data" :explore="true" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'post_shared'">
                      <cp-share-post-item :post-shared="feedItem.data" :results-url-suffix="resultsUrlSuffix" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'petition'">
                      <cp-social-feed-petition-post :key="feedItem.id" :petition="feedItem.data" :explore="true" :user="currentUser" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'election'">
                      <cp-social-feed-race-post :race="feedItem.data" :explore="true" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'new_member'">
                      <cp-social-feed-new-member-post :newMember="feedItem.data" :user="currentUser" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'lobby'">
                      <cp-social-feed-lobby-post
                        :key="feedItem.id"
                        :lobby="feedItem.data"
                        :for-share="false"
                        :explore="true"
                        :iconState="true"
                        :user="currentUser"
                      />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'poll'">
                      <cp-social-feed-poll-post
                        :key="feedItem.id"
                        :poll="feedItem.data"
                        :for-share="false"
                        :explore="true"
                        :iconState="true"
                        :user="currentUser"
                      />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'event'">
                      <cp-social-feed-livestream-post
                        v-if="feedItem.data.archive_url && feedItem.data.status == 'shared'"
                        :key="feedItem.id"
                        :playback="feedItem.data.archive_url"
                        :title="feedItem.data.title"
                        :type="'event'"
                        :data="feedItem.data"
                      ></cp-social-feed-livestream-post>
                      <cp-event-card v-else :key="feedItem.id" :event="feedItem.data" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'group'" v-margin-bottom="2">
                      <cp-group :key="feedItem.id" :group="feedItem.data" :current-user="currentUser" :type="feedItem.data.type" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'group_opinion'">
                      <cp-opinions-item :data="feedItem.data" :explore="true" :type="'group-opinions'" :reload="updateFeed" />
                    </div>
                    <div v-if="feedItem.feed_item_type == 'livestream'">
                      <cp-social-feed-livestream-post
                        :key="feedItem.id"
                        :playback="feedItem.data.archive_url"
                        :title="feedItem.data.title"
                        :type="feedItem.data.type"
                        :data="feedItem.data"
                      ></cp-social-feed-livestream-post>
                    </div>
                  </div>
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading ref="infiniteLoading" @infinite="loadHome" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading feed...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">The feed is empty!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory === 'community'">
                <CpCommunitySection
                  :current-user="currentUser"
                  :placeholderStatusPost="placeholderStatusPost"
                  :modal="showInviteDialog"
                  :results-url-suffix="resultsUrlSuffix"
                />
              </div>
              <div v-else-if="activeDataCategory == 'campaigns'" class="campaigns-feed-wrapper" key="campaigns">
                <cp-explore-campaigns-form
                  :affiliations="affiliations"
                  :current-user="currentUser"
                  :tags="campaignTags"
                  :states="states"
                  :types="types"
                  :years="years"
                  :genders="genders"
                  :results-url-suffix="resultsUrlSuffix"
                  v-bind:class="{ 'not-sticky': !!showInviteDialog }"
                  :modal="showInviteDialog"
                />
              </div>
              <div v-else-if="activeDataCategory == 'news'" class="news-feed-wrapper" key="news">
                <transition-group name="feed-fade">
                  <cp-social-feed-news-post v-for="rssItem in rssNewsItems" :key="rssItem.id" :news="rssItem" />
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading @infinite="loadNews" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading news...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">That's all!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory == 'races'" class="races-feed-wrapper" key="races">
                <transition-group name="feed-fade">
                  <cp-social-feed-race-post v-for="raceItem in races" :key="raceItem.id" :race="raceItem" />
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading @infinite="loadRaces" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading races...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">That's all!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory == 'petitions'" class="petitions-feed-wrapper" key="petitions">
                <transition-group name="feed-fade">
                  <cp-social-feed-petition-post v-for="petition in petitions" :key="petition.id" :petition="petition" :user="currentUser" />
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading @infinite="loadPetitions" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading petitions...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">That's all!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory == 'blogs'" class="blogs-feed-wrapper" key="blogs">
                <transition-group name="feed-fade">
                  <cp-social-feed-blog-post v-for="blog in blogs" :key="blog.id" :blog="blog" />
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading @infinite="loadBlogs" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading blogs...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">That's all!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory == 'polls'" class="blogs-feed-wrapper" key="polls">
                <!-- Search -->
                <cp-search-input :query="pollsQuery" @update:query="pollsQuery = $event" />

                <cp-button @click="openPollFilter" v-if="$root.isMobile" noborder><cp-icon name="filter"></cp-icon> Sort & filter</cp-button>
                <div :class="{ showFilters: isOpenPollFilter, hideFilters: !isOpenPollFilter }">
                  <div class="borderBottom">
                    <h4 class="btnText neutral5Color textAlignLeft">Sort by</h4>
                    <div v-for="sortList in pollSortArray" :key="sortList.value">
                      <label class="textAlignLeft">
                        <cp-grid>
                          <cp-grid-item :span="12">
                            <input type="radio" :id="sortList.value" :value="sortList.value" v-model="pollsSort" />
                            <span class="option-title neutral5Color">{{ sortList.title }}</span>
                          </cp-grid-item>
                        </cp-grid>
                      </label>
                    </div>
                  </div>
                  <div>
                    <div class="filterContainer">
                      <h4 class="btnText neutral5Color textAlignLeft">Filter by</h4>
                      <span class="option-title primary5Color" @click="resetPollTypes()">Reset filters</span>
                    </div>
                    <cp-grid v-for="typeList in pollTypeArray" :key="typeList.value">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <input
                          type="checkbox"
                          :id="typeList.value"
                          :value="typeList.value"
                          :name="typeList.value"
                          v-model="pollsType"
                          v-on:change="handleCheckboxChange"
                        />
                        <label :for="typeList.value">{{ typeList.title }}</label>
                      </cp-grid-item>
                    </cp-grid>
                  </div>
                </div>
                <transition-group name="feed-fade">
                  <cp-social-feed-poll-post v-for="poll in polls" :key="poll.id" :poll="poll" />
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading ref="infiniteLoadingPoll" @infinite="loadPolls" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading polls...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">That's all!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory == 'representatives'" class="blogs-feed-wrapper" key="lobbies">
                <CpRepresentativesSection :current-user="currentUser" :loadLobbies="loadLobbies" :lobbies="lobbies" />
              </div>
              <div v-else-if="activeDataCategory == 'tv'" class="blogs-feed-wrapper" key="tv">
                <div class="feed-rally-player-wrapper">
                  <cp-livestream-list :current-user="currentUser" />

                  <h3 class="social-feed-post-title">Virtual Rally Stream</h3>
                  <template v-if="rallyInCourse">
                    <cp-tv-page
                      v-if="rally.stream_url == null || rally.stream_url.length == 0"
                      :rally-in-course="rallyInCourse"
                      :explore="true"
                      :rally="rally"
                      class="feed-rally-player"
                    />
                    <iframe
                      v-else
                      width="560"
                      height="420"
                      class="rally-player"
                      :src="'https://www.youtube.com/embed/' + rally.stream_url"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </template>
                  <div
                    v-else
                    id="crowdpac-tv-player-wrapper"
                    style="position: relative; padding-bottom: 56.25%; height: 0; margin-bottom: 30px"
                    class="feed-rally-player"
                  >
                    <iframe
                      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; min-height: 420px"
                      src="https://www.youtube.com/embed/videoseries?list=PL4ZqmxF97SAFCamouyKXQfywQsi7MQ-pj&autoplay=0&loop=1"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>

                <transition-group name="feed-fade">
                  <div v-for="(video, index) in videos" :key="video.id">
                    <cp-social-feed-livestream-post
                      :playback="video.archive_url"
                      :title="video.title"
                      :type="video.video_type == 'events' ? 'event' : video.type"
                      :data="video"
                    ></cp-social-feed-livestream-post>
                  </div>
                </transition-group>
                <transition name="feed-fade">
                  <infinite-loading @infinite="loadVideos" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading...</div>
                    </div>
                    <div slot="no-more">
                      <cp-social-feed-video-post
                        v-for="videoItem in videoCrowdpacs"
                        :key="videoItem.id"
                        :crowdpac-id="videoItem.id"
                        :crowdpac-name="videoItem.name"
                        :crowdpac-slug="videoItem.slug"
                        :description="videoItem.description"
                        :candidate-img="JSON.parse(videoItem.candidate_image)"
                        :candidate-lname="videoItem.last_name"
                        :candidate-fname="videoItem.first_name"
                        :video-url="videoItem.video_url"
                      ></cp-social-feed-video-post>
                    </div>
                    <div slot="no-results">
                      <cp-social-feed-video-post
                        v-for="videoItem in videoCrowdpacs"
                        :key="videoItem.id"
                        :crowdpac-id="videoItem.id"
                        :crowdpac-name="videoItem.name"
                        :crowdpac-slug="videoItem.slug"
                        :description="videoItem.description"
                        :candidate-img="JSON.parse(videoItem.candidate_image)"
                        :candidate-lname="videoItem.last_name"
                        :candidate-fname="videoItem.first_name"
                        :video-url="videoItem.video_url"
                      ></cp-social-feed-video-post>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-else-if="activeDataCategory == 'members'" class="members-feed-wrapper" key="members">
                <cp-tabs>
                  <cp-tab name="Members" :selected="currentTabMembers == 'members'">
                    <cp-members :current-user="currentUser" :query="query" :tags="tags" :connections="'all'" />
                  </cp-tab>
                  <cp-tab name="My Connections" :selected="currentTabMembers == 'myconnnections'">
                    <span v-if="$root.isMobile">
                      <cp-tabs>
                        <cp-tab name="Followings" :selected="true">
                          <cp-members :current-user="currentUser" :query="query" :tags="tags" :connections="'myconnections'" />
                        </cp-tab>
                        <cp-tab name="Followers">
                          <cp-members :current-user="currentUser" :query="query" :tags="tags" :connections="'follower'" />
                        </cp-tab>
                        <cp-tab name="Pendings">
                          <cp-members :current-user="currentUser" :query="query" :tags="tags" :connections="'pending'" />
                        </cp-tab>
                      </cp-tabs>
                    </span>
                    <span v-else>
                      <cp-members :current-user="currentUser" :query="query" :tags="tags" :connections="'myconnections'" />
                    </span>
                  </cp-tab>
                </cp-tabs>
              </div>
              <div v-else-if="activeDataCategory == 'groups'" class="members-feed-wrapper" key="groups">
                <!-- Search -->
                <cp-search-input :query="groupsQuery" @update:query="groupsQuery = $event" />

                <cp-button @click="handleGroupFilter" v-if="$root.isMobile" noborder><cp-icon name="filter"></cp-icon> Sort & filter</cp-button>
                <div :class="{ showFilters: isOpenGroupFilter, hideFilters: !isOpenGroupFilter }">
                  <div class="filterContainer">
                    <h4 class="footnote neutral4Color textAlignLeft">Filter by</h4>
                    <span class="option-title primary5Color" @click="resetGroupsFilters()">Reset filters</span>
                  </div>
                  <div @click="handleGroupType" class="filterContainer">
                    <h4 class="subheadline2 neutral6Color textAlignLeft">Group type</h4>
                    <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                      ><minus-icon v-if="isOpenGroupType" /> <plus-icon v-else
                    /></cp-base-svg-icon>
                  </div>
                  <cp-grid v-if="isOpenGroupType" v-for="typeList in groupsTypeArray" :key="typeList.value">
                    <cp-grid-item :span="12" class="textAlignLeft">
                      <label class="textAlignLeft">
                        <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="groupsType" />
                        <span class="option-title neutral5Color">{{ typeList.title }}</span>
                      </label>
                    </cp-grid-item>
                  </cp-grid>
                  <div style="width: 100%">
                    <div @click="handleGroupTags" class="filterContainer">
                      <h4 class="subheadline2 neutral6Color textAlignLeft">Tags</h4>
                      <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                        ><minus-icon v-if="isOpenGroupTags" /> <plus-icon v-else
                      /></cp-base-svg-icon>
                    </div>
                    <cp-show-more-list v-if="isOpenGroupTags" :items="groups_tags" :label="'Tags'" @collapse="$emit('listcollapse')">
                      <template #default="{ item }">
                        <cp-grid-item :span="12" class="textAlignLeft">
                          <input class="cursorPointer" type="checkbox" :id="item.id" :value="item.id" :name="item.id" v-model="groups_tags_selected" />
                          <label class="cursorPointer" :for="item.id">{{ item.name }}</label>
                        </cp-grid-item>
                      </template>
                    </cp-show-more-list>
                  </div>

                  <div style="width: 100%">
                    <div @click="handleGroupStates" class="filterContainer">
                      <h4 class="subheadline2 neutral6Color textAlignLeft">States</h4>
                      <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                        ><minus-icon v-if="isOpenGroupStates" /> <plus-icon v-else
                      /></cp-base-svg-icon>
                    </div>
                    <cp-show-more-list v-if="isOpenGroupStates" :items="states" :label="'States'" @collapse="$emit('listcollapse')">
                      <template #default="{ item }">
                        <cp-grid-item :span="12" class="textAlignLeft">
                          <input
                            class="cursorPointer"
                            type="checkbox"
                            :id="item.abbreviation"
                            :value="item.abbreviation"
                            :name="item.abbreviation"
                            v-model="groups_states_selected"
                          />
                          <label class="cursorPointer" :for="item.abbreviation">{{ item.name }}</label>
                        </cp-grid-item>
                      </template>
                    </cp-show-more-list>
                  </div>

                  <div style="width: 100%">
                    <div @click="handleGroupPrivacy" class="filterContainer">
                      <h4 class="subheadline2 neutral6Color textAlignLeft">Privacy settings</h4>
                      <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                        ><minus-icon v-if="isOpenGroupPrivacy" /> <plus-icon v-else
                      /></cp-base-svg-icon>
                    </div>
                    <cp-grid v-if="isOpenGroupPrivacy" v-for="typeList in groupsPrivacyTypeArray" :key="typeList.value">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <label class="textAlignLeft">
                          <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="groupsPrivacyType" />
                          <span class="option-title neutral5Color">{{ typeList.title }}</span>
                        </label>
                      </cp-grid-item>
                    </cp-grid>
                  </div>
                </div>
                <cp-groups
                  :query="groupsQuery"
                  :current-user="currentUser"
                  :official-group="officialGroup"
                  :privacy-group="groupsPrivacyType"
                  :tags="groups_tags_selected"
                  :type="groupsType"
                  :states="groups_states_selected"
                />
              </div>
              <div v-else-if="activeDataCategory == 'events'" class="members-feed-wrapper" key="events">
                <!-- Search -->
                <cp-search-input :query="eventsSearch" @update:query="eventsSearch = $event" />

                <!-- Filters -->
                <cp-unstyled-button link @click="handleEventFilter" v-if="$root.isMobile" v-margin-bottom="0.5"
                  ><cp-icon name="filter"></cp-icon> Sort & filter</cp-unstyled-button
                >

                <!-- Mobile -->
                <div :class="{ showFilters: isOpenEventFilter, hideFilters: !isOpenEventFilter }">
                  <div class="filterContainer">
                    <h4 class="subheadline2 neutral4Color textAlignLeft">Filter by</h4>
                    <span class="option-title primary5Color" @click="resetEventsFilters()">Reset filters</span>
                  </div>
                  <div @click="handleEventType" class="filterContainer">
                    <h4 class="subheadline2 neutral6Color textAlignLeft">Event type</h4>
                    <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                      ><minus-icon v-if="isOpenEventType" /> <plus-icon v-else
                    /></cp-base-svg-icon>
                  </div>
                  <cp-grid v-if="isOpenEventType" v-for="typeList in eventsTypeOptions" :key="typeList.value">
                    <cp-grid-item :span="12" class="textAlignLeft">
                      <label class="textAlignLeft">
                        <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="eventsType" />
                        <span class="option-title neutral5Color">{{ typeList.title }}</span>
                      </label>
                    </cp-grid-item>
                  </cp-grid>
                  <div style="width: 100%">
                    <div @click="handleEventAssistance" class="filterContainer">
                      <h4 class="subheadline2 neutral6Color textAlignLeft">Assistance</h4>
                      <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                        ><minus-icon v-if="isOpenEventAssistance" /> <plus-icon v-else
                      /></cp-base-svg-icon>
                    </div>
                    <cp-grid v-if="isOpenEventAssistance" v-for="typeList in eventsAssistanceTypeOptions" :key="typeList.value">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <label class="textAlignLeft">
                          <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="eventsAssistanceType" />
                          <span class="option-title neutral5Color">{{ typeList.title }}</span>
                        </label>
                      </cp-grid-item>
                    </cp-grid>
                  </div>
                  <div style="width: 100%">
                    <div @click="handleEventTags" class="filterContainer">
                      <h4 class="subheadline2 neutral6Color textAlignLeft">Tags</h4>
                      <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                        ><minus-icon v-if="isOpenEventTags" /> <plus-icon v-else
                      /></cp-base-svg-icon>
                    </div>
                    <cp-show-more-list v-if="isOpenEventTags" :items="groups_tags" :label="'Tags'" @collapse="$emit('listcollapse')">
                      <template #default="{ item }">
                        <cp-grid-item :span="12" class="textAlignLeft">
                          <input class="cursorPointer" type="checkbox" :id="item.id" :value="item.id" :name="item.id" v-model="eventsTagsSelected" />
                          <label class="option-title neutral5Color" :for="item.id">{{ item.name }}</label>
                        </cp-grid-item>
                      </template>
                    </cp-show-more-list>
                  </div>

                  <div style="width: 100%">
                    <div @click="handleEventStates" class="filterContainer">
                      <h4 class="subheadline2 neutral6Color textAlignLeft">States</h4>
                      <cp-base-svg-icon :width="30" :height="32" :viewBox="'0 0 36 30'"
                        ><minus-icon v-if="isOpenEventStates" /> <plus-icon v-else
                      /></cp-base-svg-icon>
                    </div>
                    <cp-show-more-list v-if="isOpenEventStates" :items="states" :label="'States'" @collapse="$emit('listcollapse')">
                      <template #default="{ item }">
                        <cp-grid-item :span="12" class="textAlignLeft">
                          <input
                            class="cursorPointer"
                            type="checkbox"
                            :id="item.abbreviation"
                            :value="item.abbreviation"
                            :name="item.abbreviation"
                            v-model="eventsStatesSelected"
                          />
                          <label class="option-title neutral5Color" :for="item.abbreviation">{{ item.name }}</label>
                        </cp-grid-item>
                      </template>
                    </cp-show-more-list>
                  </div>
                </div>

                <!-- List events -->
                <transition-group name="feed-fade">
                  <cp-event-card v-for="event in events" :key="event.id" :event="event" v-margin-bottom="1" />
                </transition-group>

                <transition name="feed-fade">
                  <infinite-loading ref="infiniteLoadingEvents" @infinite="loadEvents" v-margin="1">
                    <div slot="spinner">
                      <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading Events...</div>
                    </div>
                    <div slot="no-more">
                      <div class="heading-4">That's all!</div>
                    </div>
                    <div slot="no-results">
                      <div class="heading-4">No events!</div>
                    </div>
                  </infinite-loading>
                </transition>
              </div>
              <div v-if="activeDataCategory == 'search'" class="search-feed-wrapper" key="search">
                <div class="feed-search-results-wrapper">
                  <cp-search
                    :affiliations="affiliations"
                    :current-user="currentUser"
                    :tags="campaignTags"
                    :states="states"
                    :types="types"
                    :years="years"
                    :genders="genders"
                    :results-url-suffix="resultsUrlSuffix"
                    v-bind:class="{ 'not-sticky': !!showInviteDialog }"
                  />
                </div>
              </div>
              <div v-if="activeDataCategory == 'post'" class="search-feed-wrapper" key="post">
                <div class="feed-post-wrapper">
                  <cp-post :user="currentUser" />
                </div>
              </div>
            </transition>
          </cp-grid-item>
          <!-- ------- RIGHT MENU ------- -->
          <transition name="feed-fade">
            <!-- Petitions -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              v-if="activeDataCategory == 'petitions'"
              key="petitions-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <div v-if="!$root.isMobile">
                  <div class="text-center">
                    <cp-base-svg-icon
                      :width="$root.isTablet ? 50 : 80"
                      :height="$root.isTablet ? 50 : 80"
                      :viewBox="'0 0 73 125'"
                      :icon-color="'currentColor'"
                      :stroke-color="'none'"
                    >
                      <petition-info-icon />
                    </cp-base-svg-icon>
                    <br />
                    <span class="title-3">How It Works</span>
                    <br />
                    <hr />
                  </div>
                  <div class="step header-label">
                    <span class="step-number">1</span>
                    <span class="step-text header-label">Create Petition</span>
                  </div>
                  <div class="step header-label">
                    <span class="step-number">2</span>
                    <span class="step-text header-label">Petition Goes Live</span>
                  </div>
                  <div class="step header-label">
                    <span class="step-number">3</span>
                    <span class="step-text header-label">Collect Signatures</span>
                  </div>
                  <div class="step header-label">
                    <span class="step-number">4</span>
                    <span class="step-text header-label">Email Out Petition</span>
                  </div>
                  <hr />
                </div>
                <cp-button-link v-bind:class="{ 'button--primary-gradient': $root.isMobile }" :href="'/petitions/create'" style="width: 100%"
                  >Start A Petition</cp-button-link
                >
                <br />
                <CpCommunityComments />
              </div>
            </cp-grid-item>
            <!-- Blogs -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              v-if="activeDataCategory == 'blogs'"
              key="blogs-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <cp-button-link v-bind:class="{ 'button--primary-gradient': $root.isMobile }" :href="'/blogs/create'" style="width: 100%"
                  >Create Blog</cp-button-link
                >
                <br />
                <CpCommunityComments />
              </div>
            </cp-grid-item>
            <!-- Polls -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              v-if="activeDataCategory == 'polls'"
              key="polls-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <div v-if="!$root.isMobile" v-margin-top="0.5">
                  <div class="text-center">
                    <i class="fal fa-poll fa-3x primary-color"></i>
                    <br />
                    <p class="content-1">Find out what users think and make your own statistics.</p>
                    <cp-button-link v-bind:class="{ 'button--primary-gradient': $root.isMobile }" :href="'/polls/create'" style="width: 100%"
                      >Create a poll</cp-button-link
                    >
                    <br />
                    <div class="borderBottom" v-margin-top="1">
                      <h4 class="content-5 textAlignLeft" v-margin-bottom="0.4">Sort by</h4>
                      <cp-grid v-for="sortList in pollSortArray" :key="sortList.value">
                        <cp-grid-item :span="12" class="textAlignLeft">
                          <label class="textAlignLeft">
                            <input class="cursorPointer" type="radio" :id="sortList.value" :value="sortList.value" v-model="pollsSort" />
                            <span class="content-1">{{ sortList.title }}</span>
                          </label>
                        </cp-grid-item>
                      </cp-grid>
                    </div>
                    <div>
                      <div class="filterContainer" v-margin-top="1">
                        <h4 class="content-5">Filter by</h4>
                        <span class="option-title primary5Color cursorPointer" @click="resetPollTypes()">Reset filters</span>
                      </div>

                      <h4 class="content-2 textAlignLeft" v-margin-bottom="0.2">Type</h4>

                      <cp-grid v-for="typeList in pollTypeArray" :key="typeList.value">
                        <cp-grid-item :span="12" class="textAlignLeft">
                          <input
                            class="cursorPointer"
                            type="checkbox"
                            :id="typeList.value"
                            :value="typeList.value"
                            :name="typeList.value"
                            v-model="pollsType"
                            v-on:change="handleCheckboxChange"
                          />
                          <label class="content-1" :for="typeList.value">{{ typeList.title }}</label>
                        </cp-grid-item>
                      </cp-grid>
                    </div>
                  </div>
                </div>
                <CpCommunityComments />
              </div>
            </cp-grid-item>
            <!-- Crowdpac TV -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              v-else-if="activeDataCategory == 'tv'"
              key="tv-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <div v-if="!$root.isMobile">
                  <div class="text-center">
                    <cp-base-svg-icon
                      :width="$root.isTablet ? 70 : 80"
                      :height="$root.isTablet ? 70 : 80"
                      :viewBox="'0 0 48 48'"
                      :icon-color="'currentColor'"
                      :stroke-color="'none'"
                    >
                      <broadcast-icon />
                    </cp-base-svg-icon>
                    <br />
                    <span class="title-3">How It Works</span>
                    <br />
                    <hr />
                  </div>
                  <div class="step header-label">
                    <span class="step-number">1</span>
                    <span class="step-text header-label">Register for Rally</span>
                  </div>
                  <div class="step header-label">
                    <span class="step-number">2</span>
                    <span class="step-text header-label">Rally Goes Live</span>
                  </div>
                  <div class="step header-label">
                    <span class="step-number">3</span>
                    <span class="step-text header-label">Collect Donations</span>
                  </div>
                  <div class="step header-label">
                    <span class="step-number">4</span>
                    <span class="step-text header-label">Hold Virtual Q/A</span>
                  </div>
                  <hr />
                </div>
                <cp-button-link :href="'/user/rallies'" block :primary-gradient="$root.isMobile">Start A Rally</cp-button-link>
                <br />
              </div>
            </cp-grid-item>
            <!-- News -->
            <cp-grid-item span="2.5" class="hidden-phone" v-else-if="activeDataCategory == 'news'" key="news-right-sidebar">
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <cp-base-svg-icon
                  :width="$root.isTablet ? 70 : 80"
                  :height="$root.isTablet ? 70 : 80"
                  :viewBox="'0 0 100 125'"
                  :icon-color="'currentColor'"
                  :stroke-color="'none'"
                >
                  <news-info-icon />
                </cp-base-svg-icon>
                <div class="title-3" style="text-align: center">
                  <span>Always Current</span>
                  <br />
                  <hr />
                </div>
                <span class="step-text header-label">Trending national & local political news.</span>
              </div>
              <CpFeaturedCampaigns v-margin-top="1" />
              <CpCommunityComments v-margin-top="1" />
              <CpSocialFeedStartCampaignPost v-margin-top="1" />
              <br />
            </cp-grid-item>
            <!-- Members -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'members'"
              key="members-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <div v-if="currentUser" class="members-connections">
                  <div class="sidebar-members-menu hidden-phone">
                    <a class="sidebar-members-link" href="/user/connections/waiting">
                      <span class="step-text header-label">Pending</span>
                      <span class="orange-text align-right">({{ waiting }})</span>
                    </a>
                  </div>
                  <div class="sidebar-members-menu hidden-phone">
                    <a class="sidebar-members-link" href="/user/connections/followed">
                      <span class="step-text header-label">Followed</span>
                      <span class="orange-text align-right">({{ followed }})</span>
                    </a>
                  </div>
                </div>
                <span class="step-text header-label">Search members by name or political issues.</span>
                <br />
                <label style="text-align: left">Search</label>
                <cp-text-input v-margin-top="0.3" v-margin-bottom="0.3" round v-model="query" aria-label="Search" class="search-input" placeholder="Name">
                  <template slot="prefix">
                    <cp-icon name="search"></cp-icon>
                  </template>
                </cp-text-input>
                <label style="text-align: left">Filter</label>
                <cp-tags-multiselect v-margin-top="0.3" class="tags-select" @user-tags-change="handleTagsChange" />
                <br />
                <CpCommunityComments />
              </div>
            </cp-grid-item>
            <!-- Grpups -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'groups'"
              key="groups-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <div v-if="!$root.isMobile" v-margin-top="0.5">
                  <div class="text-center">
                    <i class="fal fa-users icon-size fa-3x primary-color"></i>
                    <br />
                    <p class="content-1">Create a group to discuss and share with your friends about the issues you're interested in.</p>
                    <cp-button-link v-bind:class="{ 'button--primary-gradient': $root.isMobile }" :href="'/groups/create'" style="width: 100%"
                      >Create new group</cp-button-link
                    >
                    <br />
                  </div>
                </div>
                <CpSocialFeedStartCampaignPost v-margin-top="0.5" />
                <br />
                <div style="width: 100%">
                  <div class="filterContainer">
                    <h4 class="content-5">Filter by</h4>
                    <span class="option-title primary5Color cursorPointer" @click="resetGroupsFilters()">Reset filters</span>
                  </div>

                  <h4 class="content-2" v-margin-bottom="0.2">Group type</h4>

                  <cp-grid v-for="typeList in groupsTypeArray" :key="typeList.value">
                    <cp-grid-item :span="12" class="textAlignLeft">
                      <label class="textAlignLeft">
                        <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="groupsType" />
                        <span class="content-1">{{ typeList.title }}</span>
                      </label>
                    </cp-grid-item>
                  </cp-grid>
                </div>

                <div style="width: 100%">
                  <div class="filterContainer">
                    <h4 class="content-2" v-margin-bottom="0.2">Tags</h4>
                  </div>
                  <cp-show-more-list :items="groups_tags" :label="'Tags'" @collapse="$emit('listcollapse')">
                    <template #default="{ item }">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <input class="cursorPointer" type="checkbox" :id="item.id" :value="item.id" :name="item.id" v-model="groups_tags_selected" />
                        <label class="content-1" :for="item.id">{{ item.name }}</label>
                      </cp-grid-item>
                    </template>
                  </cp-show-more-list>
                </div>

                <div style="width: 100%">
                  <h4 class="content-2" v-margin-bottom="0.2">State</h4>

                  <cp-show-more-list :items="states" :label="'States'" @collapse="$emit('listcollapse')">
                    <template #default="{ item }">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <input
                          class="cursorPointer"
                          type="checkbox"
                          :id="item.abbreviation"
                          :value="item.abbreviation"
                          :name="item.abbreviation"
                          v-model="groups_states_selected"
                        />
                        <label class="content-1" :for="item.abbreviation">{{ item.name }}</label>
                      </cp-grid-item>
                    </template>
                  </cp-show-more-list>
                </div>

                <div style="width: 100%">
                  <h4 class="content-2" v-margin-bottom="0.2">Privacy settings</h4>

                  <cp-grid v-for="typeList in groupsPrivacyTypeArray" :key="typeList.value">
                    <cp-grid-item :span="12" class="textAlignLeft">
                      <label class="textAlignLeft">
                        <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="groupsPrivacyType" />
                        <span class="content-1">{{ typeList.title }}</span>
                      </label>
                    </cp-grid-item>
                  </cp-grid>
                </div>
                <CpCommunityComments />
              </div>
            </cp-grid-item>
            <!-- Events -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'events'"
              key="events-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <div v-if="!$root.isMobile" v-margin-top="0.5">
                  <div class="text-center">
                    <i class="fal fa-calendar-day fa-3x primary-color"></i>
                    <br />
                    <p class="content-1">Organize an event to get together with your group and build a strong community.</p>
                    <cp-button-link v-bind:class="{ 'button--primary-gradient': $root.isMobile }" :href="'/events/create'" style="width: 100%"
                      >Create event</cp-button-link
                    >
                    <br />
                  </div>
                </div>
                <br />
                <div style="width: 100%">
                  <div class="filterContainer">
                    <h4 class="content-5">Filter by</h4>
                    <span class="option-title primary5Color cursorPointer" @click="resetEventsFilters()">Reset filters</span>
                  </div>

                  <h4 class="content-2" v-margin-bottom="0.2">Event type</h4>

                  <cp-grid v-for="typeList in eventsTypeOptions" :key="typeList.value">
                    <cp-grid-item :span="12" class="textAlignLeft">
                      <label class="textAlignLeft">
                        <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="eventsType" />
                        <span class="content-1">{{ typeList.title }}</span>
                      </label>
                    </cp-grid-item>
                  </cp-grid>
                </div>

                <div style="width: 100%">
                  <div @click="handleEventAssistance">
                    <h4 class="content-2" v-margin-bottom="0.2">Assistance</h4>
                  </div>
                  <cp-grid v-for="typeList in eventsAssistanceTypeOptions" :key="typeList.value">
                    <cp-grid-item :span="12" class="textAlignLeft">
                      <label class="textAlignLeft">
                        <input class="cursorPointer" type="radio" :id="typeList.value" :value="typeList.value" v-model="eventsAssistanceType" />
                        <span class="content-1">{{ typeList.title }}</span>
                      </label>
                    </cp-grid-item>
                  </cp-grid>
                </div>

                <div style="width: 100%">
                  <div @click="handleEventTags">
                    <h4 class="content-2" v-margin-bottom="0.2">Tags</h4>
                  </div>
                  <cp-show-more-list :items="groups_tags" :label="'Tags'" @collapse="$emit('listcollapse')">
                    <template #default="{ item }">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <input class="cursorPointer" type="checkbox" :id="item.id" :value="item.id" :name="item.id" v-model="eventsTagsSelected" />
                        <label class="content-1" :for="item.id">{{ item.name }}</label>
                      </cp-grid-item>
                    </template>
                  </cp-show-more-list>
                </div>

                <div style="width: 100%">
                  <div @click="handleEventStates">
                    <h4 class="content-2" v-margin-bottom="0.2">States</h4>
                  </div>
                  <cp-show-more-list :items="states" :label="'States'" @collapse="$emit('listcollapse')">
                    <template #default="{ item }">
                      <cp-grid-item :span="12" class="textAlignLeft">
                        <input
                          class="cursorPointer"
                          type="checkbox"
                          :id="item.abbreviation"
                          :value="item.abbreviation"
                          :name="item.abbreviation"
                          v-model="eventsStatesSelected"
                        />
                        <label class="content-1" :for="item.abbreviation">{{ item.name }}</label>
                      </cp-grid-item>
                    </template>
                  </cp-show-more-list>
                </div>
                <CpCommunityComments v-margin-top="1" />
              </div>
            </cp-grid-item>
            <!-- Races -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'races'"
              key="races-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <cp-base-svg-icon
                  :width="$root.isTablet ? 65 : 70"
                  :height="$root.isTablet ? 65 : 70"
                  :viewBox="'0 0 511.841 426.58625'"
                  :icon-color="'currentColor'"
                  :stroke-color="'none'"
                >
                  <flag-gradient-icon />
                </cp-base-svg-icon>
                <div class="title-3" style="text-align: center">
                  <span>Run For Office</span>
                  <br />
                  <hr />
                </div>
                <span class="step-text header-label">Browse national political races from the FEC's official database.</span>
                <br />
                <CpCommunityComments />
              </div>
            </cp-grid-item>
            <!-- Explore -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'home'"
              key="explore-right-sidebar"
            >
              <div
                v-margin-top="0.5"
                class="social-feed-sidebar"
                :style="{ top: `${calculatedStickySidebarTop}px` }"
                v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }"
              >
                <CpFeaturedCampaigns />
                <CpCommunityComments />
                <CpSocialFeedSignUpPost v-if="!isUserLoginLoading && !isUserLogin" v-margin-top="0.5" />
                <CpSocialFeedStartCampaignPost v-margin-top="0.5" />
                <CpSocialFeedSubscribeToNewsletter v-margin-top="0.5" :user="currentUser" />
              </div>
              <cp-social-feed-complete-profile
                v-margin-top="0.5"
                v-if="!isUserLoginLoading && isUserLogin && currentUser && !isProfileCompleted"
                :user="currentUser"
              />
              <div v-if="loadingSuggestions" class="heading-4 hidden-phone" style="text-align: center"><vue-simple-spinner v-margin="1" />Loading...</div>
              <div v-if="!loadingSuggestions && suggestionsToShow.length > 0">
                <h2 class="H3 black-color" v-margin-top="1">Explore</h2>
                <div v-for="(suggestion, index) in suggestionsToShow" :key="index" v-margin-left="1">
                  <div v-if="suggestion.type == 'Member'" class="social-feed-post-profile-wrapper" style="margin-bottom: 12px">
                    <div class="social-feed-default-img" style="background: none; margin-right: 10px">
                      <a :href="suggestion.permalink">
                        <cp-image
                          class="position-image"
                          :src="suggestion.imageFeed"
                          circular
                          :width="$root.isMobile ? '25' : '40'"
                          :height="$root.isMobile ? '25' : '40'"
                        ></cp-image>
                      </a>
                    </div>
                    <span class="step-text header-label" style="margin-bottom: 5px">
                      <a :href="suggestion.permalink" style="color: black; display: block">
                        <span>{{ suggestion.name }}</span>
                      </a>
                      <cp-button
                        @click="followUser(suggestion.suggestionable_id, index)"
                        :loading="followingIndex === index"
                        thin
                        :disabled="followingIndex"
                        style="margin-top: 5px; border-color: var(--primary4); color: var(--primary4)"
                        >Follow</cp-button
                      >
                    </span>
                  </div>

                  <div v-else-if="suggestion.type == 'Campaign'" class="social-feed-post-profile-wrapper" style="margin-bottom: 12px">
                    <div class="social-feed-default-img" style="background: none; margin-right: 10px">
                      <a :href="suggestion.permalink">
                        <cp-image
                          class="position-image"
                          :src="suggestion.image"
                          circular
                          :width="$root.isMobile ? '25' : '40'"
                          :height="$root.isMobile ? '25' : '40'"
                        />
                      </a>
                    </div>
                    <span class="step-text header-label" style="margin-bottom: 5px">
                      <a :href="suggestion.permalink" style="color: black; display: block">
                        <v-clamp autoresize :max-lines="2">{{ suggestion.name }}</v-clamp>
                      </a>
                      <cp-button
                        @click="followCampaign(suggestion.suggestionable_id, index)"
                        :loading="followingIndex === index"
                        thin
                        :disabled="followingIndex"
                        style="margin-top: 5px; border-color: var(--primary4); color: var(--primary4)"
                        >Follow</cp-button
                      >
                    </span>
                  </div>

                  <div v-else-if="suggestion.type == 'Candidate'" class="social-feed-post-profile-wrapper" style="margin-bottom: 12px">
                    <div class="social-feed-default-img" style="background: none; margin-right: 10px">
                      <a :href="suggestion.permalink">
                        <cp-image
                          class="position-image"
                          :src="suggestion.imageFeed"
                          circular
                          :width="$root.isMobile ? '25' : '40'"
                          :height="$root.isMobile ? '25' : '40'"
                        />
                      </a>
                    </div>
                    <span class="step-text header-label" style="margin-bottom: 5px">
                      <a :href="suggestion.permalink" style="color: black; display: block">
                        <span style="display: block">{{ suggestion.name }}</span>
                      </a>
                      <cp-button
                        @click="followCandidate(suggestion.suggestionable_id, index)"
                        :loading="followingIndex === index"
                        thin
                        :disabled="followingIndex"
                        style="margin-top: 5px; border-color: var(--primary4); color: var(--primary4)"
                        >Follow</cp-button
                      >
                    </span>
                  </div>
                </div>
                <h2 v-if="new_members.length" class="H3 black-color hidden-phone" v-margin-top="1">New members</h2>
                <div v-if="loadingNewMembers" class="heading-4 hidden-phone" style="text-align: center"><vue-simple-spinner v-margin="1" />Loading...</div>
                <div v-else class="hidden-phone" v-margin-left="1">
                  <div v-for="(new_member, index) in new_members" :key="new_member.id">
                    <div class="social-feed-post-profile-wrapper" style="margin-bottom: 12px">
                      <div class="profile-img social-feed-default-img new-member-image" style="background: none">
                        <a :href="new_member.permalink">
                          <cp-image
                            class="position-image"
                            :src="new_member.imageFeed"
                            circular
                            :width="$root.isMobile ? '25' : '40'"
                            :height="$root.isMobile ? '25' : '40'"
                          ></cp-image>
                        </a>
                      </div>
                      <span class="step-text header-label" style="margin-bottom: 5px">
                        <a :href="new_member.permalink" style="color: black; word-break: break-word">
                          <v-clamp autoresize :max-lines="2">{{ new_member.fullname }}</v-clamp>
                        </a>
                        <cp-tooltip-toggle v-if="currentUser" :for="'tooltip-' + new_member.id">
                          <button type="button" class="tooltip-btn">
                            {{ new_member.tag.length }}
                            {{ new_member.tag.length == 1 ? 'shared issue' : 'shared issues' }}
                          </button>
                        </cp-tooltip-toggle>
                        <cp-tooltip :id="'tooltip-' + new_member.id" :light="true">
                          <p v-for="tag in new_member.tag" class="name-tag" :key="tag.id">{{ tag.name }}</p>
                        </cp-tooltip>
                        <cp-button
                          @click="followNewUser(new_member.id, index)"
                          :loading="indexClickedNewUser === index"
                          thin
                          style="margin-top: 5px; border-color: var(--primary4); color: var(--primary4)"
                          >Follow</cp-button
                        >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="!loadingSuggestions && suggestionsToShow.length == 0 && currentUser" style="width: 100%; margin-left: 30px">
                <h2 style="font-size: 18px">Congrats! You are following all our suggested users, politicans, and campaigns.</h2>
                <cp-button @click="handleFollowMore" style="width: 90%">Follow More</cp-button>
              </div>
            </cp-grid-item>
            <!-- Search top - Lupita -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'search'"
              key="search-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <cp-base-svg-icon :width="70" :height="70" :viewBox="'-20 -20 140 140'" :icon-color="'currentColor'" :stroke-color="'none'">
                  <search-icon />
                </cp-base-svg-icon>
                <div class="title-3" style="text-align: center">
                  <span>Search CrowdBlue</span>
                  <br />
                  <hr />
                </div>
                <span class="step-text header-label">Search users, campaigns, candidates, elections, news, tv, and petitions.</span>
                <br />
              </div>
            </cp-grid-item>
            <!-- Post -->
            <cp-grid-item
              span="2.5"
              v-bind:class="{ 'mobile-fixed-bottom-sidebar': $root.isMobile }"
              class="hidden-phone"
              v-else-if="activeDataCategory == 'post'"
              key="post-right-sidebar"
            >
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <CpLatestNews :news-id="typeParam === 'News' ? idParam : 0" style="border-bottom: 1px solid var(--neutral3)" />
                <CpSocialFeedStartCampaignPost v-margin-top="0.5" />
                <CpCommunityComments />
                <CpSocialFeedSubscribeToNewsletter v-margin-top="0.5" :user="currentUser" />
                <CpExploreNewMembers v-margin-top="0.5" />
              </div>
            </cp-grid-item>
            <!-- Lobbying -->
            <cp-grid-item span="2.5" class="hidden-phone" v-else-if="activeDataCategory == 'representatives'" key="lobbying-right-sidebar">
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <cp-base-svg-icon :width="50" :height="50" :viewBox="'0 0 113 97'" :icon-color="'currentColor'" :stroke-color="'none'">
                  <lobby-sidebar-right-icon />
                </cp-base-svg-icon>
                <h4 class="subheadline1 primary-color text-center" v-margin-top="1">Contact Your Reps</h4>
                <span class="footnote neutral4-color text-center"
                  >Endorse or oppose a US Senator and Congressperson by zip code to help spark local change.</span
                >
                <cp-button
                  @click="startLobby"
                  block
                  :primary-gradient="$root.isMobile"
                  v-margin-top="1"
                  style="border-color: var(--primary4); color: var(--primary4)"
                  >Contact Representative</cp-button
                >
                <CpCommunityComments v-margin-top="1" />
              </div>
              <br />
            </cp-grid-item>
            <!-- Community -->
            <cp-grid-item span="2.5" class="hidden-phone" v-else-if="activeDataCategory == 'community'" key="community-right-sidebar">
              <div class="social-feed-sidebar" v-bind:class="{ mobile: $root.isMobile, tablet: $root.isTablet, 'not-sticky': !!showInviteDialog }">
                <CpFeaturedCampaigns />
                <CpCommunityComments />
              </div>
              <br />
            </cp-grid-item>
          </transition>
        </cp-grid>
      </cp-box-content>
    </cp-box>
    <cp-profile-dialog-zip
      :states="states"
      :showZipDialog="showZipDialog"
      :setCurrentUserZip="setCurrentUserZip"
      :handleZipDialog="handleZipDialog"
      :handleBannerZip="handleBannerZip"
    />
    <CpWelcomeUserDialog
      v-if="isOpenWelcomeUser && isSocialNetworkSignUp"
      :handleDialog="handleOpenWelcomeUser"
      :currentUser="currentUser"
      @sidebarLinkClicked="handleSidebarLinkClicked"
    />
    <cp-download-app-dialog v-if="isOpenDownloadApp" :handleDialog="handleOpenDownloadApp" />
    <cp-download-app-mobile-dialog v-if="isOpenDownloadAppMobile" :handleDialog="handleOpenDownloadAppMobile" />
    <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="loginCallbackAction" />
  </div>
</template>

<style>
.text-banner-zip {
  cursor: pointer;
  width: 50%;
}

.banner-news {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  height: auto;
  background-color: #ffe3da;
}

.content-required {
  border: 0.5px solid red;
}

.pinnedText {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  color: #ff4814;
  float: right;
  margin: 5% 5% -7% 0%;
}

.title-3 {
  font-family: 'Proxima-Nova', Helvetica, sans-serif;
  font-weight: bold;
}

.align-right {
  float: right;
}

div.tablet .social-feed-wrapper iframe {
  min-height: 0px;
}

div.social-feed-post-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0px;
}

div.social-feed-sidebar.not-sticky,
div.social-feed-sidebar.not-sticky .multiselect,
div.not-sticky .feed-rally-player,
div.not-sticky .feed-rally-player iframe,
div.not-sticky .progress-bar.search-result__progress-bar,
div.not-sticky .progress-bar.search-result__progress-bar .progress-bar__fill,
.controlled-image__container.position-image {
  position: initial !important;
}

.controlled-image__container.position-image-mobile img {
  position: initial !important;
  width: 100%;
}

.position-image {
  border: 2px var(--primary2) solid;
  border-radius: 50%;
}

.position-image img {
  height: 40px;
  object-fit: cover;
}

div.social-feed-sidebar.not-sticky .multiselect__select {
  display: none;
}

div.post-action-button {
  width: auto;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
}

div.post-action-text {
  padding-left: 5px;
  font-size: 1.1em;
}

div.post-action-button svg {
  padding-top: 2px;
}

div.not-sticky .search-page__sidebar {
  position: initial;
}

div.post-action {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

div.post-action-button.primary {
  background: #fe8c00;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #f83600, #fe8c00);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #f83600, #fe8c00);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.social-feed-wrapper.not-sticky .controlled-image__container {
  position: initial;
}

.social-feed-wrapper.not-sticky .vue-simple-spinner {
  animation: none !important;
}

div.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
}

div.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10px;
}

div.social-feed-post-profile-wrapper .profile-name {
  font-size: 1.3em;
  padding-bottom: 10px;
}

div.social-feed-post-profile-wrapper .post-time {
  color: #666;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}

span.social-feed-default-img {
  display: flex;
  align-items: center;
  justify-content: center;
}

a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

.none {
  display: none;
}

.flex {
  display: flex;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1.5em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}

div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
}

.social-feed-post-wrapper > * {
  width: 100%;
}

.button-new-posts-container {
  z-index: 9999;
  top: 20px;
  width: 100%;
  position: fixed;
  display: flex;
  justify-content: center;
}
.button-new-posts {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
}

.profile-img {
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-right: 12px;
}

div.social-feed-box-wrapper {
  position: relative;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}

.social-feed-default-img {
  background: #ffe3da;
  color: var(--highlight);
}

div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}

div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

div.social-feed-post {
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

div.social-feed-post-description {
  padding-top: 10px;
}

video.candidate-video-player {
  width: 100%;
  height: auto;
}

header.social-feed-title-header {
  text-align: center;
  margin-bottom: 30px;
}

.feed-fade-enter-active,
.feed-fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.feed-fade-enter,
.feed-fade-leave-to {
  opacity: 0;
}

div.social-feed-sidebar {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.header-label {
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  color: #121212;
}

.mini-recipient {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

span.mini-recipient__title {
  margin-bottom: 0px;
}

span.mini-recipient__subtitle {
  margin-top: 0px;
}

div.step {
  min-width: 165px;
  padding: 7px 0px 0px 7px;
}

.social-feed-sidebar.tablet .step-number {
  width: 25px;
  height: 25px;
  line-height: 25px;
  font-size: 15px;
}

.mobile-fixed-bottom-sidebar .social-feed-sidebar.mobile {
  display: block;
  height: 39px;
}

.social-feed-sidebar.tablet .step {
  padding-left: 10px;
}

span.step-text {
  padding-left: 5px;
}

.box__content.tablet {
  margin: 25px !important;
}

.box__content.mobile {
  margin: var(--gutter) !important;
}

span.step-number {
  margin: 10px 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-size: 20px;
  line-height: 30px;
  display: inline-block;
  background: #fe8c00;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #f83600, #fe8c00);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #f83600, #fe8c00);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

input[type='checkbox'] {
  accent-color: #ff4814;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
  padding: 15px;
  position: relative;
  max-width: 100% !important;
}

.mobile-fixed-bottom-sidebar {
  position: fixed;
  background: white;
  width: 100% !important;
  bottom: 0px;
  left: 0px;
  margin: 0px;
  z-index: 9999;
}

.mobile-fixed-bottom-sidebar .button {
  border-radius: 0;
  box-shadow: -2px 0 4px var(--muted);
}

.tags-select {
  width: 100%;
}

.social-feed-sidebar.tablet .option__icon {
  display: none !important;
}

.social-feed-sidebar.tablet .option__title {
  font-size: 0.7em;
}

.social-feed-sidebar.tablet .multiselect__select {
  width: 25px;
}

.search-input {
  margin-left: -1px;
  width: 100%;
  max-width: calc(100% - 2px) !important;
}

.members-connections {
  padding-left: 5px;
  width: 100%;
}

.sidebar-members-menu {
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 13px;
  border-bottom: 1px solid #e5e5e5;
  padding: 15px 0px;
  margin-bottom: 10px;
}

.sidebar-members-link {
  color: #000;
  font-weight: 700;
}

.sidebar-link.active {
  background: rgba(255, 190, 171, 0.22);
  border-radius: 90px;
  padding: 10px;
  margin-left: -10px;
}

.orange-text {
  color: #ff4814;
  padding: 0 5px;
}

.feed-rally-player-wrapper {
  margin-bottom: var(--gutter);
}

.feed-rally-player {
  width: 100%;
  height: auto;
  border-radius: 6px;
  background-color: #000000;
}

.rally-player {
  background-color: #000000;
  width: 100%;
}

video:active,
video:focus {
  outline: none;
}

.fluid-width-video-wrapper {
  position: relative !important;
  padding-bottom: 56.25% !important;
  padding-top: 30px !important;
  height: 0 !important;
  overflow: hidden !important;
}

.new-member-image {
  width: 50px;
}

@media only screen and (min-width: 1024px) and (max-width: 1365px) {
  .new-members-title {
    font-size: 20px;
  }
}

.tooltip-btn {
  display: block;
  color: var(--primary-blue-600);
  background: none;
  border: none;
  padding: 0;
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  text-align: left;
}

.name-tag {
  text-align: center;
  background: var(--primary-blue-200);
  border-radius: 10px;
  color: var(--primary-blue-600);
  border-color: var(--primary-blue-100);
  padding: 5px 10px;
  font-weight: bold;
  font-size: 20px;
}

.borderBottom {
  border-bottom: 1px solid #dadada;
  padding-bottom: 10px;
  width: 100% !important;
}

.hideFilters {
  display: none;
}

.showFilters {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.filterContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btnText {
  font-weight: 700;
  font-size: 20px;
}

.option-title {
  font-weight: 400;
  font-size: 17px;
}

.textAlignLeft {
  text-align: left;
}

.primary5Color {
  color: #f16543;
}

.neutral5Color {
  color: #555555;
}

.cursorPointer {
  cursor: pointer;
}

input[type='radio'] {
  accent-color: #ed572f;
}

.filter-list {
  margin: 15px 0;
}

.sign-up-post-mobile {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.my-representatives {
  border-top: 1px solid var(--neutral3);
  padding-top: 8px;
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .text-banner-zip {
    width: 60%;
  }
}

@media only screen and (max-width: 767px) {
  .text-banner-zip {
    width: 90%;
    padding-right: 10px;
  }
  .position-image img {
    height: 25px;
  }
}
</style>
